import { isMobile } from "../../breakpoints";
import React from "react";

export default function progressiveLoad(frames, Component) {
  return class ProgressiveLoad extends React.Component {
    constructor(props) {
      super(props);
      this.state = { frame: isMobile() ? 0 : frames - 1 };
      this.update = this.update.bind(this);
    }

    componentDidMount() {
      var { frame } = this.state;
      if (frame + 1 < frames) {
        this.requestId = window.requestAnimationFrame(this.update);
      }
    }

    componentWillUnmount() {
      if (this.requestId) {
        window.cancelAnimationFrame(this.requestId);
      }
    }

    update() {
      var { frame } = this.state;
      this.setState({ frame: frame + 1 }); // eslint-disable-line react/no-set-state
      if (frame + 1 < frames) {
        this.requestId = window.requestAnimationFrame(this.update);
      } else {
        delete this.requestId;
      }
    }

    render() {
      var { frame } = this.state;
      return <Component {...this.props} frame={frame} />;
    }
  };
}
